import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import './App.scss';
import { LocalizationProvider } from '@mui/x-date-pickers';

import { AppBar, Box, Toolbar, Typography } from '@mui/material';

import OneparkLogo from './assets/logos/Onepark_logo.svg';
import ApprovePage from './pages/request/ApprovePage';

// Pages
import HomePage from './pages/HomePage/HomePage';
import PgPage from './pages/PgPage';
import RequestNewPage from './pages/request/NewPage';
import RequestStatusPage from './pages/request/StatusPage';

function App() {
  return (
    <div className="App">
      <LocalizationProvider dateAdapter={AdapterMoment}>
        <Box sx={{ flexGrow: 1 }}>
          <AppBar position="static" sx={{ backgroundColor: '#292929' }}>
            <Toolbar>
              <Typography component="div" sx={{ flexGrow: 1 }}>
                Lufthavn Parkering
              </Typography>
              <Box sx={{ flexGrow: 1 }} />
              <div
                style={{
                  width: '100px',
                  height: '40px',
                  backgroundImage: `url(${OneparkLogo})`,
                  backgroundSize: 'contain',
                  backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                }}
              ></div>
            </Toolbar>
          </AppBar>
        </Box>
        <BrowserRouter>
          <Routes>
            <Route index element={<HomePage />} />
            <Route path="/request/new" element={<RequestNewPage />} />
            <Route path="/request/:id" element={<RequestStatusPage />} />
            <Route path="/approve/:aid/request/:id" element={<ApprovePage />} />
            <Route path="/pg/:aid/:id" element={<PgPage />} />
            <Route path="/tls/:aid/:id" element={<PgPage />} />
            <Route path="*" element={<HomePage />} />
          </Routes>
        </BrowserRouter>
      </LocalizationProvider>
    </div>
  );
}

export default App;
